import React from "react"
import autobind from "class-autobind"
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import strings from "../../../../localization/strings"
import { Paper, Menu, MenuItem } from "material-ui"
enum EDayActions {
    Clone,
    Delay,
    DeleteExtraDay,
}
interface IProps {
    handleClone(): void
    handleDelay(): void
    handleDeleteExtraDay(): void
}
interface IState {
    showActionsMenu: boolean
}

export default class ScheduleTimeinfoDetailWeekViewDayActionIcon extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            showActionsMenu: false
        }
        autobind(this)
    }

    render() {
        if (!this.props.handleClone && !this.props.handleDelay && !this.props.handleDeleteExtraDay)
            return null
        return (
            <div style={{ position: "absolute", right: -2, top: 2, }}>
                <MoreVertIcon
                    data-intercom-target="ScheduleDailyView-Btn-VertIcon"
                    style={{ color: "white", padding: 0, width: 17, height: 17 }}
                    onClick={() => this.setState({ showActionsMenu: !this.state.showActionsMenu })}
                />
                {this.state.showActionsMenu &&
                    <ScheduleTimeinfoDetailWeekViewDayActionIconMenu
                        showClone={this.props.handleClone ? true : false}
                        showDelay={this.props.handleDelay ? true : false}
                        showDeleteExtraDay={this.props.handleDeleteExtraDay ? true : false}
                        handleChoose={action => {
                            switch (action) {
                                case EDayActions.Clone:
                                    this.props.handleClone()
                                    break
                                case EDayActions.Delay:
                                    this.props.handleDelay()
                                    break
                                case EDayActions.DeleteExtraDay:
                                    this.props.handleDeleteExtraDay()
                                    break

                            }

                            this.setState({ showActionsMenu: false })
                        }}
                    />
                }
            </div>
        )
    }
}


interface IScheduleTimeinfoDetailWeekViewDayActionIconMenuProps {
    showClone: boolean
    showDelay: boolean
    showDeleteExtraDay: boolean
    handleChoose(action: EDayActions): void
}

const ScheduleTimeinfoDetailWeekViewDayActionIconMenu: React.SFC<IScheduleTimeinfoDetailWeekViewDayActionIconMenuProps> = (props: IScheduleTimeinfoDetailWeekViewDayActionIconMenuProps) => {
    return (
        <Paper style={{ position: "absolute", top: 30, left: 0, zIndex: 10 }}>
            <Menu style={{ textAlign: "left" }}>
                {props.showClone &&
                    <MenuItem
                        primaryText={strings.Clone_Shifts}
                        onClick={() => props.handleChoose(EDayActions.Clone)}
                    />
                }
                {props.showDelay &&
                    <MenuItem
                        primaryText={strings.Schedule_Delay}
                        onClick={() => props.handleChoose(EDayActions.Delay)}
                    />
                }
                {props.showDeleteExtraDay &&
                    <MenuItem
                        primaryText={strings.Delete_Extra_Day}
                        onClick={() => props.handleChoose(EDayActions.DeleteExtraDay)}
                    />
                }
            </Menu>
        </Paper>
    )
}